import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Task } from './task.interface';
import { TaskService } from './task.service';
import user, { UserState } from './users/user.store';

const service = new TaskService();

export interface TaskState {
   tasks: Array<Task>;
   user?: UserState;
   query?: LocationQuery;
   activeIndex: number;
   userTasksAmount: number;
}

const TaskStore: Module<TaskState, StoreState> = {
   namespaced: true,
   state: {
      tasks: [],
      activeIndex: 0,
      userTasksAmount: 0,
   },
   getters: {},
   mutations: {
      SET_TASKS(state, tasks: Array<Task>) {
         state.tasks = tasks;
      },
      SET_QUERY(state, query?: LocationQuery) {
         state.query = query;
      },
      SET_USER_TASKS_AMOUNT(state, amount: number) {
         state.userTasksAmount = amount;
      },
   },
   actions: {
      async getTasks(context, { query, cancelable }: { query?: LocationQuery; cancelable?: boolean }) {
         const response = await service.getTasks(query, cancelable);
         return response;
      },
      async createTask(context, task: Task) {
         const response = await service.createTask(task);
         return response;
      },
      async updateTask(context, payload: { taskId: number; task: Task }) {
         const response = await service.putTask(payload.task, payload.taskId);
         return response;
      },
      async patchTask(context, { taskId, path, value }: { taskId: number; path: keyof Task; value: string | number }) {
         const response = await service.patchTask(taskId, path, value);
         return response;
      },
      async completeTask(context, taskId: number) {
         const response = await service.completeTask(taskId);
         return response;
      },
      async bulkCompleteTasks(context, payload: { taskIds: number[]; completedByUserId?: number; completedAt?: string }) {
         const response = await service.bulkCompleteTasks(payload.taskIds, payload.completedByUserId, payload.completedAt);
         return response;
      },
      async incompleteTask(context, taskId: number) {
         const response = await service.incompleteTask(taskId);
         return response;
      },
   },
   modules: {
      user,
   },
};

export default TaskStore;
